package com.milta.core.localization.translations.pl

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Ładowanie…",
    errorNoConnection = "Nie można połączyć się z serwerem — sprawdź swoje połączenie.",
    errorGeneric = "Wystąpił błąd. Spróbuj ponownie później.",
    contractLockedNotice = "🔒 Kontrakt wyjściowy (format JSON) pozostaje zablokowany — jest dodawany automatycznie po stronie serwera po edytowanym tekście, aby nigdy nie zepsuć ekstrakcji w produkcji.",
    notModifiedLabel = "Wartość domyślna — nigdy nie zmieniona",
    modifiedOnPrefix = "Zmodyfikowano",
    resetToDefaultAction = "↺ Przywróć wartości domyślne",
    editableBodyLabel = "✏️ Edytowalna treść — reguły biznesowe",
    markdownBoldSnippet = "**pogrubiony tekst**",
    markdownItalicSnippet = "*kursywa*",
    markdownCodeSnippet = "`kod`",
    markdownHeadingSnippet = "## Nagłówek",
    markdownBulletSnippet = "- element listy",
    markdownNumberedSnippet = "1. element listy",
    markdownQuoteSnippet = "> cytat",
    previewToggleEdit = "✏️ Edytuj",
    previewToggleShow = "👁 Podgląd",
    contractFooterLabel = "🔒 Kontrakt wyjściowy — zablokowany, dodawany automatycznie",
    actionErrorOffline = "Niepowodzenie — sprawdź swoje połączenie.",
    actionErrorGeneric = "Zapis nieudany, spróbuj ponownie.",
    unsavedChangesNotice = "● Niezapisane zmiany",
    savingAction = "Zapisywanie…",
    saveAction = "Zapisz zmiany",
)
